import axios from 'axios'
import APIConstants from '../../constants/api'

const axiosFRExt = axios.create({
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

const axiosExt = axios.create({
  headers: {
    'Content-Type': 'application/json'
  }
})

const axiosInt = axios.create({
  baseURL: APIConstants.BASE_API_URI,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
})

const axiosSec = axios.create({
  baseURL: APIConstants.BASE_API_URI + 'secured/',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
})

axiosSec.interceptors.request.use(config => {
  const method = config.method.toUpperCase()
  if (method !== 'OPTIONS' && method !== 'GET') {
    config.headers = {
      ...config.headers,
      'X-CSRF-TOKEN': localStorage.csrf
    }
  }
  return config
})

axiosSec.interceptors.response.use(null, error => {
  if (error.response && error.response.config && error.response.status === 401) {
    // If 401 by expired access cookie, we do a refresh request
    return axiosInt.post('/refresh', {}, { headers: { 'X-CSRF-TOKEN': localStorage.csrf } })
      .then(response => {
        localStorage.csrf = response.data.csrf
        localStorage.signedIn = true
        // After another successfull refresh - repeat original request
        let retryConfig = error.response.config
        retryConfig.headers['X-CSRF-TOKEN'] = localStorage.csrf
        return axiosInt.request(retryConfig)
      }).catch(error => {
        delete localStorage.csrf
        delete localStorage.signedIn
        // redirect to signin if refresh fails
        location.replace('/')
        return Promise.reject(error)
      })
  } else {
    return Promise.reject(error)
  }
})

export { axiosFRExt, axiosExt, axiosInt, axiosSec }
